import { type PlaybackController } from 'components/VideoPlayer/controller/PlaybackController';
import { useControllerState } from 'solox';
import { type SelectedStream } from 'src/core/video/types';

/**
 * Returns the currently selected stream, or undefined if no stream is selected.
 */
export function useSelectedStream(
  playbackController: PlaybackController,
  playerId: string,
): SelectedStream | undefined {
  return useControllerState(playbackController.state, () =>
    playbackController.getSelectedStream(playerId),
  );
}
